<template>
  <div class="custom-cpn">

  </div>
</template>


<script>
export default {
  name: 'CustomCpn',
  data() {
    return {}
  },
  porps: {},
  computed: {},
  methods: {
    startWorker(cats, childrenList, cat_list, plat) {
      const actions = [
        {
          message: 'transformPickerOptions',
          func: function (cats, childrenList, cat_level_list, cat_list, plat) {
            return _transformPickerOptions(
              cats,
              childrenList,
              cat_level_list,
              cat_list,
              plat
            )
            function _transformPickerOptions(
              _cats,
              _childrenList,
              cat_level_list,
              cat_list,
              plat
            ) {
              let catArr = []
              for (let key in _cats) {
                let catId = _cats[key]
                if (catId == '0' || !_childrenList[catId]) {
                  continue
                }
                if (cat_level_list == 'all') {
                  let {
                    category_id,
                    is_parent,
                    chd,
                    name,
                    only_show,
                    level,
                    parent_id,
                    sale,
                  } = _childrenList[catId]
                  const catNameStr = getCatName(_childrenList[catId])
                  const catNameOldNewStr = getCatNameOldNew(
                    _childrenList[catId]
                  )
                  let catCid = category_id ? category_id : catId
                  const custom =
                    _childrenList[catId].custom === undefined
                      ? false
                      : _childrenList[catId].custom + ''
                  const subName = _childrenList[catId].sub_name || ''
                  if (plat == 'jd' && level == 4) {
                    catCid = `${parent_id}_${catCid}`
                  }
                  let cat_tip = ''
                  let _cat = {
                    id: catCid,
                    label: catNameStr,
                    labelOldNew: catNameOldNewStr,
                    disabled: only_show,
                    is_parent,
                    custom,
                    sub_name: subName,
                    nocheck: level == '0' ? true : false,

                    // fix_id: catCid,
                    // fix_platform: 'all',
                    // checked: false,
                    // open: false,
                    // pId: ['0'],
                    // path: ["女装/女士精品"],
                    // sub_name: "",
                    // support_plat_name: '淘宝',
                    // top_id: '16'
                  }
                  if (custom) {
                    _cat._id = _childrenList[catId]._id
                  }

                  if (is_parent) {
                    let _children = _transformPickerOptions(
                      chd,
                      _childrenList,
                      cat_level_list,
                      cat_list,
                      plat
                    )
                    if (_children.length) {
                      _cat.children = _children
                    }
                  }
                  if (sale) {
                    _cat.sale = sale
                  }
                  catArr.push(_cat)
                } else {
                  if (_childrenList[catId]) {
                    let {
                      category_id,
                      is_parent,
                      chd,
                      name,
                      only_show,
                      level,
                      parent_id,
                      sale,
                    } = _childrenList[catId]
                    const catNameStr = getCatName(_childrenList[catId])
                    const catNameOldNewStr = getCatNameOldNew(
                      _childrenList[catId]
                    )
                    let catCid = category_id ? category_id : catId
                    if (plat == 'jd' && level == 4) {
                      catCid = `${parent_id}_${catCid}`
                    }

                    only_show = check_permission(
                      catId,
                      _childrenList,
                      cat_list
                    )[1]
                    let has_priv = check_permission(
                      catId,
                      _childrenList,
                      cat_list
                    )[0]
                    let _cat = null
                    const custom =
                      _childrenList[catId].custom === undefined
                        ? false
                        : _childrenList[catId].custom + ''
                    const subName = _childrenList[catId].sub_name || ''
                    if (has_priv) {
                      _cat = {
                        id: catCid,
                        label: catNameStr,
                        labelOldNew: catNameOldNewStr,
                        disabled: only_show == true,
                        nocheck: level == '0' ? true : false,
                        is_parent: is_parent,
                        custom,
                        sub_name: subName,
                      }
                      if (custom) {
                        _cat._id = _childrenList[catId]._id
                      }
                    } else {
                      continue
                    }
                    if (is_parent) {
                      let _children = _transformPickerOptions(
                        chd,
                        _childrenList,
                        cat_level_list,
                        cat_list,
                        plat
                      )
                      if (_children.length) {
                        _cat.children = _children
                      }
                    }
                    if (sale) {
                      _cat.sale = sale
                    }
                    // 如果前面类目父类已经添加,就不要重复添加
                    let index = catArr.findIndex((item) => {
                      return item.id == _cat.id
                    })
                    if (index > -1) {
                      continue
                    } else {
                      catArr.push(_cat)
                    }
                  } else {
                    continue
                  }
                }
              }
              return catArr
            }
            function getCatName({
              name,
              name_en,
              category_name,
              category_name_en,
              name_source,
            }) {
              return name
            }
            // 镜界类目是改名后的, 需要获取原始类目名
            function getCatNameOldNew({
              name,
              name_en,
              category_name,
              category_name_en,
              name_source,
              name_old_new,
            }) {
              if (name_old_new) {
                return name_old_new
              } else {
                return ''
              }
            }
            function check_permission(cid, __childrenList, cat_list) {
              let pids = get_parents(cid, __childrenList)
              let has_priv = false,
                only_show = true
              //1.父类目是否有权限
              pids.forEach(function (pid, i) {
                let cat = __childrenList[pid]
                let level = cat.level
                if (cat_list['level' + level]) {
                  cat_list['level' + level].forEach(function (o, j) {
                    if (!o) return
                    if (o.cat_id == pid || o.cat_id == '0') {
                      has_priv = true
                      only_show = false
                    }
                  })
                } else {
                  [].forEach(function (o, j) {
                    if (o.cat_id == pid) {
                      has_priv = true
                      only_show = false
                    }
                  })
                }
              })
              //2.子类目有权限的，需展示父类目
              if (!has_priv) {
                Object.keys(cat_list).forEach(function (v) {
                  cat_list[v].forEach(function (o, i) {
                    if (!o) return
                    let parents = get_parents(o.cat_id, __childrenList)
                    if (parents.indexOf(cid) >= 0) {
                      has_priv = true
                      only_show = true
                    }
                  })
                })
              } else {
                only_show = false
              }

              return [has_priv, only_show]
            }
            function get_parents(cid, ___childrenList) {
              let cat = ___childrenList[cid]
              let pids = [cid]
              if (cat && cat.custom) {
                while (cat && cat.parent_key) {
                  pids.push(cat.parent_key)
                  cat = ___childrenList[cat.parent_key]
                }
              } else {
                while (cat && cat.parent_id != '0') {
                  pids.push(cat.parent_id)
                  cat = ___childrenList[cat.parent_id]
                }
              }

              return pids
            }
          },
        },
      ]
      let worker = this.$worker.create(actions)
      let postMessageActionName = 'transformPickerOptions'
      return worker.postMessage(postMessageActionName, [
        cats,
        childrenList,
        cat_list,
        cat_list,
        plat,
      ])
    },
    startOverseaWorker(cats, childrenList, cat_list, plat) {
      const actions = [
        {
          message: 'transformPickerOptions',
          func: function (cats, childrenList, cat_level_list, cat_list, plat) {
            return _transformPickerOptions(
              cats,
              childrenList,
              cat_level_list,
              cat_list,
              plat
            )
            function _transformPickerOptions(
              _cats,
              _childrenList,
              cat_level_list,
              cat_list,
              plat
            ) {
              let catArr = []
              for (let key in _cats) {
                let catId = _cats[key]
                if (catId == '0' || !_childrenList[catId]) {
                  continue
                }
                if (cat_level_list == 'all') {
                  let {
                    category_id,
                    is_parent,
                    chd,
                    // name,
                    // name_en,
                    // category_name,
                    // category_name_en,
                    only_show,
                    level,
                    parent_id,
                  } = _childrenList[catId]
                  const catNameStr = getCatName(_childrenList[catId])
                  const catNameOldNewStr = getCatNameOldNew(
                    _childrenList[catId]
                  )
                  let catCid = category_id ? category_id : catId
                  const custom =
                    _childrenList[catId].custom === undefined
                      ? false
                      : _childrenList[catId].custom + ''
                  const subName = _childrenList[catId].sub_name || ''
                  if (plat == 'jd' && level == 4) {
                    catCid = `${parent_id}_${catCid}`
                  }
                  let cat_tip = ''
                  let _cat = {
                    id: catCid,
                    label: catNameStr,
                    labelOldNew: catNameOldNewStr,
                    disabled: only_show,
                    is_parent,
                    custom,
                    sub_name: subName,

                    // fix_id: catCid,
                    // fix_platform: 'all',
                    // checked: false,
                    // open: false,
                    // pId: ['0'],
                    // path: ["女装/女士精品"],
                    // sub_name: "",
                    // support_plat_name: '淘宝',
                    // top_id: '16'
                  }
                  if (custom) {
                    _cat._id = _childrenList[catId]._id
                  }

                  if (is_parent) {
                    let _children = _transformPickerOptions(
                      chd,
                      _childrenList,
                      cat_level_list,
                      cat_list,
                      plat
                    )
                    if (_children.length) {
                      _cat.children = _children
                    }
                  }
                  catArr.push(_cat)
                } else {
                  if (_childrenList[catId]) {
                    let {
                      category_id,
                      is_parent,
                      chd,
                      name,
                      only_show,
                      level,
                      parent_id,
                    } = _childrenList[catId]
                    const catNameStr = getCatName(_childrenList[catId])
                    const catNameOldNewStr = getCatNameOldNew(
                      _childrenList[catId]
                    )
                    let catCid = category_id ? category_id : catId
                    if (plat == 'jd' && level == 4) {
                      catCid = `${parent_id}_${catCid}`
                    }

                    only_show = check_permission(
                      catId,
                      _childrenList,
                      cat_list
                    )[1]
                    let has_priv = check_permission(
                      catId,
                      _childrenList,
                      cat_list
                    )[0]
                    let _cat = null
                    const custom =
                      _childrenList[catId].custom === undefined
                        ? false
                        : _childrenList[catId].custom + ''
                    const subName = _childrenList[catId].sub_name || ''
                    if (has_priv) {
                      _cat = {
                        id: catCid,
                        label: catNameStr,
                        labelOldNew: catNameOldNewStr,
                        disabled: only_show == true,
                        is_parent: is_parent,
                        custom,
                        sub_name: subName,
                      }
                      if (custom) {
                        _cat._id = _childrenList[catId]._id
                      }
                    } else {
                      continue
                    }
                    if (is_parent) {
                      let _children = _transformPickerOptions(
                        chd,
                        _childrenList,
                        cat_level_list,
                        cat_list,
                        plat
                      )
                      if (_children.length) {
                        _cat.children = _children
                      }
                    }
                    // 如果前面类目父类已经添加,就不要重复添加
                    let index = catArr.findIndex((item) => {
                      return item.id == _cat.id
                    })
                    if (index > -1) {
                      continue
                    } else {
                      catArr.push(_cat)
                    }
                  } else {
                    continue
                  }
                }
              }
              return catArr
            }
            function getCatName({
              name,
              name_en,
              category_name,
              category_name_en,
              name_source,
            }) {
              return name
            }
            // 镜界类目是改名后的, 需要获取原始类目名
            function getCatNameOldNew({
              name,
              name_en,
              category_name,
              category_name_en,
              name_source,
              name_old_new,
            }) {
              if (name_old_new) {
                return name_old_new
              } else {
                return ''
              }
            }
            function check_permission(cid, __childrenList, cat_list) {
              let pids = get_parents(cid, __childrenList)
              let has_priv = false,
                only_show = true
              //1.父类目是否有权限
              pids.forEach(function (pid, i) {
                let cat = __childrenList[pid]
                let level = cat.level
                if (cat_list['level' + level]) {
                  cat_list['level' + level].forEach(function (o, j) {
                    if (!o) return
                    if (o.cat_id == pid || o.cat_id == '0') {
                      has_priv = true
                      only_show = false
                    }
                  })
                } else {
                  [].forEach(function (o, j) {
                    if (o.cat_id == pid) {
                      has_priv = true
                      only_show = false
                    }
                  })
                }
              })
              //2.子类目有权限的，需展示父类目
              if (!has_priv) {
                Object.keys(cat_list).forEach(function (v) {
                  cat_list[v].forEach(function (o, i) {
                    if (!o) return
                    let parents = get_parents(o.cat_id, __childrenList)
                    if (parents.indexOf(cid) >= 0) {
                      has_priv = true
                      only_show = true
                    }
                  })
                })
              } else {
                only_show = false
              }

              return [has_priv, only_show]
            }
            function get_parents(cid, ___childrenList) {
              let cat = ___childrenList[cid]
              let pids = [cid]
              if (cat && cat.custom) {
                while (cat && cat.parent_key) {
                  pids.push(cat.parent_key)
                  cat = ___childrenList[cat.parent_key]
                }
              } else {
                while (cat && cat.parent_id != '0') {
                  pids.push(cat.parent_id)
                  cat = ___childrenList[cat.parent_id]
                }
              }

              return pids
            }
          },
        },
      ]
      let worker = this.$worker.create(actions)
      let postMessageActionName = 'transformPickerOptions'
      return worker.postMessage(postMessageActionName, [
        cats,
        childrenList,
        cat_list,
        cat_list,
        plat,
      ])
    },
  },
  created() {},
}
</script>

<style lang="less" scoped>
</style>
